import type { RouteObject } from 'react-router-dom';

import { lazy, Suspense } from 'react';

const ChatPage = lazy(() => import('./pages/chat-page').then((m) => ({ default: m.ChatPage })));

const lazyChat = (
  <Suspense fallback={null}>
    <ChatPage />
  </Suspense>
);

export const chatRoutes: RouteObject[] = [
  { path: 'c', element: lazyChat },
  { path: 'c/:conversationId', element: lazyChat },
];
